import { useEffect, useState, useRef } from "react";
import { Dropdown, Button, Form } from "react-bootstrap";
import { Search, XLg, ThreeDotsVertical } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchWardList } from "../../../store/actions/wardsAction";
import { userSearch } from "../../../store/reducerSlice/wards";
import TableDesign from "../../common/table/TableDesign";
import DeleteWardPopup from "./DeleteWardPopup";
import AlertMessage from "./AlertMessage";
import ToggelActivatateWardPopup from "./ToggelActivatateWardPopup";
import ShowWardUrlPopup from "./ShowWardUrlPopup";
import ManageWard from "./ManageWard";
import { resetPopup } from "../../../store/reducerSlice/wards";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
// import ManageUcrt from "./ManageUcrt";
const tableHeadings = [
  {
    label: "S. No.",
  },
  {
    label: "Geography",
    sort: "location",
  },

  {
    label: "Ward Name",
    sort: "name",
  },
  {
    label: "Ward Type",
    sort: "type",
  },

  {
    label: "No. of Beds",
    sort: "numberOfBeds",
    whiteSpace: "text-wrap",
  },
  {
    label: "Occupied Beds",
    whiteSpace: "text-wrap",
    // sort: "occupiedBeds",
  },
  {
    label: "Reserve Beds",
    whiteSpace: "text-wrap",
    // sort: "reservedBeds",
  },
  {
    label: "Available Beds",
    whiteSpace: "text-wrap",
    // sort: "availableBeds",
  },
  {
    label: "Discharging Today",
    whiteSpace: "text-wrap",
    // sort: "reservedBeds",
  },
  {
    label: "Discharge Expired",
    whiteSpace: "text-wrap",
    // sort: "availableBeds",
  },

  {
    label: "Status",
    sort: "isActive",
  },
  {
    label: "Action",
  },
];

const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const WardList = () => {
  const admin = useSelector((state) => state.admin);
  console.log("admin",admin);
  const { adminDetail } = admin;
  const [modalShow, setModalShow] = useState(false);
  const [status, setStatus] = useState("all");
  const [selectWard, setSelectWard] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [searchText, setSearchText] = useState();
  const [activeTab, setActiveTab] = useState("");
  const searchInputRef = useRef(null);
  const [filterOption, setFilterOption] = useState({
    page: 1,
    search: "",
    orderBy: "createdAt",
    orderIn: -1,
  });
  const [alertRec, setAlertRec] = useState(null);
  const [alertModalShow, setAlertModalShow] = useState(false);
  const [deleteRec, setDeleteRec] = useState(null);
  const [wardLink, setWardLink] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [wardLinkModalShow, setWardLinkModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);
  const [toggleActivateStatus, setToggleActivateStatus] = useState(null);
  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);
  const [modalUcrtShow, setModalUcrtShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    wards,
    filtered,
    pagination,
    isLoader,
    isRecordUpdated,
    isRecordAdded,
    error: apiError,
  } = useSelector((state) => {
    return state.wards;
  });
  const page = pagination?.currentPage;

  const cc = filtered || wards;

  useEffect(() => {
    if (location?.state?.previousActiveTab) {
      setActiveTab(location?.state?.previousActiveTab);
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state?.previousActiveTab]);

  useEffect(() => {
    if (searchText || searchText === "") {
      filterHandler({ search: searchText, page: 1 });
    }
  }, [searchText]);
  window.history.replaceState({}, document.title);

  useEffect(() => {
    if (!location?.state?.previousActiveTab) {
      dispatch(fetchWardList(filterOption)).then(({ payload }) => {
        if (payload.success) {
          hideErrorRes();
        } else {
          setIsShow(true);
        }
      });
    }
  }, [filterOption, isRecordUpdated]);

  const filterStatusHandler = (obj) => {
    let val = { ...filterOption };
    val.status = obj.status;
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const hideHandle = () => {
    setModalShow(false);
    setModalUcrtShow(false);
    setSelectWard(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setWardLinkModalShow(false);
    setShowResult(false);
    setAlertModalShow(false);
  };
  const createUpdateWard = (ward) => {
    dispatch(resetPopup());
    setModalShow(true);
    setSelectWard(ward);
    setTitle("Update Ward");
    setMessage("Ward updated successfully!");
    setShowResult(true);
  };
  const createUpdateUcrt = (ward) => {
    dispatch(resetPopup());
    setModalUcrtShow(true);
    setSelectWard(ward);
    setTitle("Add UCRT");
    setMessage("UCRT updated successfully!");
    setShowResult(true);
  };
  const addNewWard = () => {
    dispatch(resetPopup());
    setModalShow(true);
    setSelectWard(null);
    setTitle("Add Ward");
    setMessage("Ward has been added successfully.");
    setShowResult(true);
  };
  const deleteEventHandler = (rec) => {
    setDeleteRec(rec?._id);
    setDeleteModalShow(true);
  };

  const wardLinkEventHandler = (rec) => {
    setWardLink(rec?.slug);
    setWardLinkModalShow(true);
  };

  const toggleActivateEventHandler = (rec) => {
    dispatch(resetPopup());
    setToggleActivateRec(rec);
    setToggleActivateStatus(rec?.isActive);
    setToggleActivateModalShow(true);
  };

  const formatedDate = (val) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(val).toLocaleDateString([], options);
  };

  const navigateTodetail = (val) => {
    navigate(`/ward-detail/${val._id}`);
  };
  const hideHandlerRes = () => {
    dispatch(resetPopup());
    setTitle(null);
    setMessage(null);
    setShowResult(false);
  };

  const hideErrorRes = () => {
    setIsShow(false);
  };
  const showAlert = () => {
    dispatch(resetPopup());
    setAlertRec(null);
    setAlertModalShow(true);
  };
  return (
    <>
      <div className="container">
        {/* <ManageUcrt
        show={modalUcrtShow}
        onHide={hideHandle}
        title={selectWard ? "Add UCRT" : "Add UCRT"}
        selectWard={selectWard}
        setModalShow={setModalShow}
        adminDetail={adminDetail}
        /> */}
        <ManageWard
          show={modalShow}
          onHide={hideHandle}
          title={selectWard ? "Edit Ward" : "Add Ward"}
          selectWard={selectWard}
          setModalShow={setModalShow}
          adminDetail={adminDetail}
        />
        <DeleteWardPopup
          onHide={hideHandle}
          deleteRec={deleteRec}
          deleteModalShow={deleteModalShow}
          setAlertModalShow={setAlertModalShow}
        />
        <AlertMessage
          onHide={hideHandle}
          alertRec={alertRec}
          alertModalShow={alertModalShow}
          setDeleteModalShow={setDeleteModalShow}
        />
        <ShowWardUrlPopup
          onHide={hideHandle}
          wardLink={wardLink}
          wardLinkModalShow={wardLinkModalShow}
          setWardLinkModalShow={setWardLinkModalShow}
        />
        <ToggelActivatateWardPopup
          onHide={hideHandle}
          toggleActivateRec={toggleActivateRec}
          toggleActivateStatus={toggleActivateStatus}
          toggleActivateModalShow={toggleActivateModalShow}
          setToggleActivateModalShow={setToggleActivateModalShow}
        />

        <h1 className="main-title">Manage Wards</h1>

        <div className="block">
        {adminDetail?.wardTypes && !adminDetail?.isAdmin && adminDetail?.wardTypes.length === 0 ? (
            ""
          ) : !adminDetail?.wardTypes?.includes("none") && (
          <Button
            className="btn-primary"
            href="#"
            style={{ float: "right" }}
            onClick={() => addNewWard()}
          >
            Add Ward
          </Button>
          )}
          <div className="searchForm">
            <Search className="searchSvg1" />
            <Form.Control
              type="text"
              name="search"
              ref={searchInputRef}
              placeholder="Search"
              onKeyUp={debounce((e) => setSearchText(e.target.value), 200)}
            />
            {searchText?.length > 0 && (
              <XLg
                className="searchSvg2"
                onClick={(e) => {
                  searchInputRef.current.value = "";
                  setSearchText("");
                }}
              />
            )}
          </div>
        </div>

        <TableDesign
          className="mt-5 pt-4"
          {...{
            title: "List of Wards",
            tableHeadings,
            filterHandler,
            pagination,
            filterOption,
            setFilterOption,
            isLoader,
          }}
        >
          {cc && cc.length ? (
            cc.map((row, i) => {
              if (row)
                return (
                  <tr key={i} className="align-items-center">
                    <td align="center">
                      {i + 1 + (page > 1 && (page - 1) * 10)}
                    </td>
                    <td>
                      {row.isActive && row.isClientLocation && row.isClientWardType ? (
                        <span
                          onClick={() => navigate(`/ward-detail/${row._id}`)}
                          style={{
                            color: "#737761",
                            fontWeight: 600,
                            cursor: "pointer",
                          }}
                        >
                          {row.location}
                        </span>
                      ) : !row.isClientLocation || !row.isClientWardType ? (
                        <span
                          onClick={showAlert}
                          style={{
                            color: "#737761",
                            fontWeight: 600,
                            cursor: "pointer",
                          }}
                        >
                          {row.location}
                        </span>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.location}
                        </span>
                      )}
                    </td>
                    <td className="py-auto">
                      {row.isActive && row.isClientLocation && row.isClientWardType ? (
                        <span
                          onClick={() => navigate(`/ward-detail/${row._id}`)}
                          style={{
                            color: "#6546bb",
                            fontWeight: 600,
                            cursor: "pointer",
                          }}
                        >
                          {row.name}
                        </span>
                      ) : !row.isClientLocation || !row.isClientWardType ? (
                        <span
                          onClick={showAlert}
                          style={{
                            color: "#6546bb",
                            fontWeight: 600,
                            cursor: "pointer",
                          }}
                        >
                          {row.name}
                        </span>
                      ): (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.name}
                        </span>
                      )}
                    </td>
                    <td>
                      {row.isActive ? (
                        <span style={{ color: "#737761", fontWeight: 600 }}>
                          {row.type}
                        </span>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.type}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.isActive ? (
                        <span style={{ color: "#737761", fontWeight: 600 }}>
                          {row.numberOfBeds}
                        </span>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.numberOfBeds}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.isActive ? (
                        <span style={{ color: "#737761", fontWeight: 600 }}>
                          {row.occupiedBeds}
                        </span>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.occupiedBeds}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.isActive ? (
                        <span style={{ color: "#737761", fontWeight: 600 }}>
                          {row.reservedBeds}
                        </span>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.reservedBeds}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.isActive ? (
                        <span style={{ color: "#737761", fontWeight: 600 }}>
                          {row.availableBeds}
                        </span>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.availableBeds}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.isActive ? (
                        <span style={{ color: "#737761", fontWeight: 600 }}>
                          {row.todayExpectedDischarges}
                        </span>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.todayExpectedDischarges}
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.isActive ? (
                        <span style={{ color: "#737761", fontWeight: 600 }}>
                          {row.expiredDischarges}
                        </span>
                      ) : (
                        <span style={{ color: "#C8C6CE", fontWeight: 600 }}>
                          {row.expiredDischarges}
                        </span>
                      )}
                    </td>
                    <td>
                      {row.isActive ? (
                        <span style={{ color: "#10940D", fontWeight: 600 }}>
                          Active
                        </span>
                      ) : (
                        <span style={{ color: "red", fontWeight: 600 }}>
                          Inactive
                        </span>
                      )}
                    </td>
                    <td align="center">
                      {row.isClientLocation && row.isClientWardType ? (
                        <Dropdown align="end">
                          <Dropdown.Toggle>
                            <ThreeDotsVertical />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {row.isActive ? (
                              <>
                                <Dropdown.Item
                                  href="#"
                                  onClick={() =>
                                    navigate(`/ward-detail/${row._id}`)
                                  }
                                >
                                  Manage
                                </Dropdown.Item>
                                <Dropdown.Item
                                  href="#"
                                  onClick={() => createUpdateWard(row)}
                                >
                                  Edit
                                </Dropdown.Item>
                               
                                <Dropdown.Item
                                  href="#"
                                  onClick={() =>
                                    toggleActivateEventHandler(row)
                                  }
                                >
                                  Deactivate
                                </Dropdown.Item>
                              </>
                            ) : (
                              <>
                                <Dropdown.Item
                                  href="#"
                                  onClick={() =>
                                    toggleActivateEventHandler(row)
                                  }
                                >
                                  Activate
                                </Dropdown.Item>
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      ) : null}
                    </td>
                  </tr>
                );
            })
          ) : (
            <tr>
              <td colSpan="8">No Result Found</td>
            </tr>
          )}
        </TableDesign>
      </div>
      {(isRecordUpdated || isRecordAdded) && showResult && (
        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordAdded,
            isRecordUpdated,
            successMsg: message,
            title: title,
          }}
        />
      )}
      {apiError && (
        <ApiResponsePopup
          {...{
            hideHandlerRes: hideErrorRes,
            isRecordUpdated: isShow,
            title: "Error",
            successMsg: "data loaded successfully!!",
            errorRes: apiError?.message,
          }}
        />
      )}
    </>
  );
};

export default WardList;
